import { type ReactElement, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useExportContacts } from '@features/contacts/hooks/useExportContacts'
import { ExportDrawer } from '@features/exports/elements/ExportDrawer'
import { ExportFileTypeSection } from '@features/exports/elements/ExportFileTypeSection'
import { type ExportDocumentFileType } from '@features/exports/types/exportDocumentFileType'

import { contactsExportFileTypes, defaultContactsExportFileType } from './constants/contactsExportFileTypes'

interface ContactsExportDrawerProps {
  isOpen: boolean
  onClose: () => void
}

export const ContactsExportDrawer = ({ isOpen, onClose }: ContactsExportDrawerProps): ReactElement => {
  const [fileType, setFileType] = useState<ExportDocumentFileType | undefined>(defaultContactsExportFileType)
  const { t } = useTranslation()
  const { exportContacts } = useExportContacts()

  const handleDrawerClose = useCallback(() => {
    setFileType(defaultContactsExportFileType)
    onClose()
  }, [onClose])

  const handleDrawerExport = useCallback(() => {
    if (!fileType) {
      return
    }

    exportContacts(fileType, { isCustomerOnly: true })
    handleDrawerClose()
  }, [exportContacts, fileType, handleDrawerClose])

  return (
    <ExportDrawer
      isExportDisabled={!fileType}
      isOpen={isOpen}
      onClose={handleDrawerClose}
      onExport={handleDrawerExport}
      title={t('contacts.export_drawer.title')}
    >
      <ExportFileTypeSection fileTypes={contactsExportFileTypes} onChange={setFileType} value={fileType} />
    </ExportDrawer>
  )
}
